// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__Tl1eP","subfooter":"Footer_subfooter__Q_1hT","logo":"Footer_logo__PM82v","container":"Footer_container__iN3aW","item":"Footer_item__ikrg0"};